<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66667 3.5H12.25M4.66667 7H12.25M4.66667 10.5H12.25M1.75 3.5H1.75583M1.75 7H1.75583M1.75 10.5H1.75583" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
